import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import { Grid, Text } from 'theme-ui';
import ContentFaqQuestion from '~/components/Content/Faq/Question';
import CTAButton from '~/components/Generic/CTAButton';
import { useCustomAnalytics } from '~/hooks/utils/customAnalytics';

const ContentFaqTopic = ({ topic, setCurrentQuestion, currentQuestion, fromHomePage }) => {
  const { trackClickLink } = useCustomAnalytics();
  const { name, questions } = topic;
  return (
    <Grid
      sx={{
        gridTemplateColumns: ['1fr', null, 'minmax(min-content, 1fr) 2fr'],
        '&:not(:last-of-type)': {
          pb: '9.6rem',
          mb: '9.6rem',
          borderBottom: '1px solid black',
        },
      }}
    >
      <Text
        as="h3"
        sx={{
          mt: 0,
          marginBottom: ['4rem', null, '4.8rem'],
          maxWidth: ['100%', null, '43.8rem'],
          variant: 'text.h3',
          height: 'fit-content',
          lineHeight: '0.9',
          letterSpacing: '-4%',
          fontSize: ['3.6rem', '5.6rem'],
          '& > p': {
            my: 0,
          },
        }}
        dangerouslySetInnerHTML={{ __html: name }}
      />
      <Grid>
        {questions.map((question) => (
          <ContentFaqQuestion
            key={question.id}
            question={question}
            topic={topic}
            setCurrentQuestion={setCurrentQuestion}
            currentQuestion={currentQuestion}
          />
        ))}
        {fromHomePage && (
          <CTAButton
            sx={{
              mt: ['4rem', '4.8rem'],
              justifySelf: ['center', null, 'start'],
            }}
            title="See more"
            to="/support"
            locationDetail="FAQ Section"
            onClick={() =>
              trackClickLink({ linkType: 'link', page: 'support', title: 'support', locationDetail: 'FAQ Section' })
            }
            as={Link}
            baseColor="Black"
            variant="Filled"
            size="Medium"
          >
            See more
          </CTAButton>
        )}
      </Grid>
    </Grid>
  );
};

export default ContentFaqTopic;

ContentFaqTopic.propTypes = {
  faq: PropTypes.shape({
    name: PropTypes.string,
    questions: PropTypes.array,
  }),
};
